module.exports = __webpack_public_path__ + "fonts/d798f933ca2a3fa8d39fb3ac80cea706-Roboto-Italic.eot";